;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');
	var Collection = APP.module('Collection');


	View.LeaguesJoin = Marionette.ItemView.extend({
		template: null,
		ui: {
			'join_btn':  '',
			'show_more': ''
		},
		events: {
			'click @ui.join_btn':  'joinLeague',
			'click @ui.show_more': 'loadMore'
		},
		initialize: function() {
			this.scrollToTop();
			this.leagues = this.getOption('leagues');
			this.filter  = {};
			this.offset  = 0;
			this.limit   = 10;
			this.is_all  = false;

			this.listenTo(this.leagues, 'leagues:errors', this.showErrors);
			this.listenTo(this.leagues, 'leagues:join:success', this.leagueJoined);
			this.listenTo(APP.vent, 'leagues_join_filter:change', this.updateFilter);
			const rounds = new Collection.Rounds();

			this.model.set({
				leagues: [],
				is_all:  false,
				final_round_id: rounds.final_round_id
			});

			this.showPreloader();
			this.leagues
				.show_for_join()
				.fetch()
				.then(_.bind(this.initTemplate, this));
		},
		initTemplate: function() {
			this.is_all = this.leagues.length < this.limit;

			return this.setModelData().render().hidePreloader();
		},
		setModelData: function() {
			this.model.set({
				leagues: this.leagues.toJSON(),
				is_all:  this.is_all
			});

			return this;
		},
		updateFilter: function(filter) {
			this.filter = filter;
			this.offset = 0;
			this.showPreloader();

			this.leagues
				.show_for_join()
				.fetch({ data: this.filter })
				.then(_.bind(this.initTemplate, this));

			return this;
		},
		joinLeague: function(e) {
			var id = +$(e.currentTarget).data('id');

			this.showPreloader();
			this.leagues.findWhere({ id: id }).join();

			return this;
		},
		leagueJoined: function(league_id) {
			this.hidePreloader();
			this.trigger('leagues_join:success', league_id);

			return this;
		},
		loadMore: function() {
			var count_leagues = this.leagues.length,
				data          = this.filter;

			this.showPreloader();
			this.offset += this.limit;
			data.offset = this.offset;

			this.leagues
				.show_for_join()
				.fetch({remove: false, data: data})
				.then(_.bind(function() {
					this.is_all = (this.leagues.length - count_leagues) < this.limit;

					return this.hidePreloader().setModelData().render();
				}, this));
		}
	});

}(window, APP, Backbone, Marionette, $, _));